import SurveyStepSecteurContainer from "./SurveyStepSecteurContainer";
export default SurveyStepSecteurContainer;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSecteur/index.js